import { render, staticRenderFns } from "./CustoEventoTerceiroForm.vue?vue&type=template&id=1833bd66&scoped=true"
import script from "./CustoEventoTerceiroForm.vue?vue&type=script&lang=js"
export * from "./CustoEventoTerceiroForm.vue?vue&type=script&lang=js"
import style0 from "./CustoEventoTerceiroForm.vue?vue&type=style&index=0&id=1833bd66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1833bd66",
  null
  
)

export default component.exports